import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady } = props;

  React.useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement("video-js");

      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current.appendChild(videoElement);

      const player = (playerRef.current = videojs(videoElement, options, () => {
        //videojs.log('player is ready');
        onReady && onReady(player);
      }));

      // Add error event handler for better debugging and recovery
      player.on("error", () => {
        const error = player.error();
        console.error("VideoJS error:", error);

        // For network errors (code 2), try to recover
        if (error && error.code === 2) {
          console.log("Network error detected, attempting recovery...");
          setTimeout(() => {
            if (playerRef.current && !playerRef.current.isDisposed()) {
              player.error(null);
              player.src(options.sources);
              player.load();
              if (options.autoplay) {
                player
                  .play()
                  .catch((e) => console.log("Autoplay recovery failed:", e));
              }
            }
          }, 3000);
        }
      });

      // Log when player is playing
      player.on("playing", () => {
        console.log("VideoJS: Stream is playing");
      });

      // Log when player is waiting for data
      player.on("waiting", () => {
        console.log("VideoJS: Waiting for stream data...");
      });

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;

      // Only update source if URL actually changed, don't pause
      player.autoplay(options.autoplay);
      player.src(options.sources);
      // Don't pause - let it transition smoothly
    }
  }, [options, onReady]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    return () => {
      // Access current ref value at cleanup time, not at effect setup time
      if (playerRef.current && !playerRef.current.isDisposed()) {
        console.log("Disposing VideoJS player");
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []); // Empty array - only cleanup on unmount

  return (
    // Fill the feed layer (.video-stage owns the box). With `fill: true` in the
    // options, video.js sizes the <video> to this container. The line overlay
    // is now a sibling in function3.js, not a child here.
    <div
      data-vjs-player
      style={{ position: "relative", width: "100%", height: "100%" }}
    >
      <div ref={videoRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
};

export default VideoJS;
